export default "__VITE_ASSET__Dsd3fHKf__"